import type { ViewProps } from "@-/com.npmjs.react-native";
import { FrostedBackdropTarget } from "@-/dev.improve.haniverse.components.ui.frosted-surface";
import {
  ScrollEdgeTopExtensionContext,
  ScrollEdgeTopInsetContext,
} from "@-/dev.improve.haniverse.modules.scroll-edge-effect";

/** Capture the page beneath a sheet; keep its scroll-edge viewport local to that page. */
export function TopSheetBackdropTarget({ children, ...props }: ViewProps) {
  return (
    <FrostedBackdropTarget {...props}>
      <ScrollEdgeTopExtensionContext value={0}>
        <ScrollEdgeTopInsetContext value={0}>{children}</ScrollEdgeTopInsetContext>
      </ScrollEdgeTopExtensionContext>
    </FrostedBackdropTarget>
  );
}
